import React, { useState, useEffect } from 'react';
import { Box, Container } from '@mui/material';
import HeroSection from './whitepaper/HeroSection';
import ExecutiveSummary from './whitepaper/ExecutiveSummary';
import ChallengeSection from './whitepaper/ChallengeSection';
import ArchitectureSection from './whitepaper/ArchitectureSection';
import CoreCapabilities from './whitepaper/CoreCapabilities';
import ROISection from './whitepaper/ROISection';
import UseCasesSection from './whitepaper/UseCasesSection';
import ImplementationSection from './whitepaper/ImplementationSection';
import TechnologySection from './whitepaper/TechnologySection';
import SuccessStories from './whitepaper/SuccessStories';
import GetStartedSection from './whitepaper/GetStartedSection';
import '../whitepaper.css';

const SIEMWhitepaper = () => {
  const [activeSection, setActiveSection] = useState(0);

  const sections = [
    'Executive Summary',
    'The Challenge',
    'Architecture',
    'Core Capabilities',
    'Business Value',
    'Use Cases',
    'Implementation',
    'Technology',
    'Success Stories',
    'Get Started'
  ];

  return (
    <Box className="whitepaper-root">
      <HeroSection />
     

      <Container maxWidth="xl" sx={{ py: 8 }}>
        <ExecutiveSummary />
        <ChallengeSection />
        <ArchitectureSection />
        <CoreCapabilities />
        <ROISection />
        <UseCasesSection />
        <ImplementationSection />
        <TechnologySection />
        <SuccessStories />
        <GetStartedSection />
      </Container>
    </Box>
  );
};

export default SIEMWhitepaper;